import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementReferencesView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        References
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will mirror the Access reference selector
        {' '}
        <strong>cbPreferencesList</strong>
        {' '}
        from
        {' '}
        <strong>form_frmProcurementMainSubFormReferences.txt</strong>
        , rendering read-only reference grids such as Contract Statistics, Pending Payment, Virtual Warehouse, Received,
        Consignment, PTBF Fixation, CS Fixation, CP List/Bank, Futures Allocation, List and Valo, Futures List, Bank,
        Package, and Delivery Place / Certification references.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

